import React from "react";

/**
 * Tacho de la fila de acciones. Misma familia que `EyeIcon`, `DownloadIcon`,
 * `CheckIcon` y `EmailIcon`: grilla de 24, trazo de 2 y `currentColor`, así el
 * botón que lo envuelve decide el color.
 *
 * No se reusa `icons/cards/DeleteIcon` porque ese es de la familia rellena de
 * las tarjetas de CRUD y se pinta con `fill` (lo hacen `ItemCardToolBar` y
 * `ProgressBar`), que acá no aplica.
 */
export default function TrashIcon(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      height={props.height}
      width={props.width}
      aria-hidden="true"
      focusable="false"
      fill="none"
      stroke={props.color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ ...props.style, cursor: "pointer" }}
      {...props}
    >
      <path d="M3 6h18" />
      <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6" />
      <path d="M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2" />
      <path d="M10 11v6" />
      <path d="M14 11v6" />
    </svg>
  );
}

TrashIcon.defaultProps = {
  height: `2.2rem`,
  width: `2.2rem`,
  color: "currentColor",
};
